module.exports = __webpack_public_path__ + "static/media/ETC-icon.2f40e27f.svg";